export default class Validators {
  constructor() {}

  static validateCap(value: string) {
    const rule = new RegExp("^[0-9]{5}$");
    return rule.test(value);
  }
}
